import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Users, Stethoscope, ClipboardList, Calendar } from 'lucide-react';
import api from '../lib/api';
import { toast } from 'sonner';

export default function SuperAdminDashboard() {
  const [metrics, setMetrics] = useState({
    active_doctors: 0,
    total_patients: 0,
    total_consultations: 0,
    scheduled_appointments: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = async () => {
    try {
      const response = await api.get('/metrics');
      setMetrics(response.data);
    } catch (error) {
      toast.error('Error al cargar métricas');
    } finally {
      setLoading(false);
    }
  };

  const stats = [
    {
      name: 'Médicos Activos',
      value: metrics.active_doctors,
      icon: Stethoscope,
      color: 'bg-primary',
      testId: 'active-doctors-stat'
    },
    {
      name: 'Pacientes Registrados',
      value: metrics.total_patients,
      icon: Users,
      color: 'bg-secondary',
      testId: 'total-patients-stat'
    },
    {
      name: 'Consultas Realizadas',
      value: metrics.total_consultations,
      icon: ClipboardList,
      color: 'bg-orange-500',
      testId: 'total-consultations-stat'
    },
    {
      name: 'Citas Programadas',
      value: metrics.scheduled_appointments,
      icon: Calendar,
      color: 'bg-purple-500',
      testId: 'scheduled-appointments-stat'
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="dashboard-title">
          Panel de Administración
        </h1>
        <p className="text-muted-foreground mt-2">
          Resumen general del sistema ClinIA Perú
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <Card key={stat.name} className="p-6 card-hover" data-testid={stat.testId}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{stat.name}</p>
                <p className="text-3xl font-bold mt-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                  {loading ? '...' : stat.value}
                </p>
              </div>
              <div className={`w-12 h-12 rounded-lg ${stat.color} flex items-center justify-center`}>
                <stat.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Recent Activity Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-6" data-testid="recent-activity-card">
          <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Actividad Reciente
          </h2>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground text-center py-8">
              No hay actividad reciente para mostrar
            </p>
          </div>
        </Card>

        <Card className="p-6" data-testid="system-status-card">
          <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Estado del Sistema
          </h2>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm">Base de Datos</span>
              <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                Operativo
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">API Backend</span>
              <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                Operativo
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm">Supabase Auth</span>
              <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
                Operativo
              </span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
